import { RootState } from '@store/rootReducer'

export const selectShowModalType = (state: RootState) => state.modal.showModalType
export const selectCustomTextProps = (state: RootState) => state.modal.customTextProps
export const selectWhatsNewData = (state: RootState) => state.modal.whatsNewData
